import { IProductCard } from '@src/components/product-card/product-card.types'
import { TrackConfig } from '@src/quince-components/src/hocs/withTracking'
import type { SvdCardToken } from '@src/types/svd-product-card.types'

import { ProductLite } from '../../domains/Product'
import Product from '../../domains/Product/Product'
import { ProductVariantOption } from '../../domains/ProductVariant'
import PubSub from '../PubSub'

export interface ProductBuyNowState {
  showPopUp: boolean
  product?: Product | ProductLite | null
  productCard?: IProductCard
  selectedOptions: ProductVariantOption[]
  trackerKey: string
  searchQuery?: string
  position?: number
  trackerData?: TrackConfig
  tabData?: Record<string, string | boolean>
  /**
   * SVD quick-add identity — carried so the modal can resolve the full product the SVD-native way
   * (by internal `productId` + `selectedAttributes`) when the SVD purchase flow (Path B) ships.
   * Additive + optional: Path A (the enrich-by-spid modal) ignores it; every legacy/DS caller leaves
   * it undefined. See `product-buy-now-ds/index.tsx` for the Path-B router branch.
   */
  svdCardToken?: SvdCardToken
}

interface SetProductBuyNowPayload {
  product?: Product | ProductLite
  productCard?: IProductCard
  selectedOptions: ProductVariantOption[]
  trackerKey?: string
  searchQuery?: string
  position?: number
  productClickTrackConfig?: TrackConfig
  tabData?: Record<string, string | boolean>
  /** SVD quick-add identity (Path B). Optional + additive — see `ProductBuyNowState.svdCardToken`. */
  svdCardToken?: SvdCardToken
}

class ProductBuyNowStateManager extends PubSub {
  private state: ProductBuyNowState

  constructor() {
    super()
    this.state = {
      showPopUp: false,
      product: null,
      productCard: undefined,
      selectedOptions: [],
      trackerKey: '',
      searchQuery: undefined,
      position: undefined,
      tabData: undefined,
    }
  }

  showBuyNowPopUp = (payload: SetProductBuyNowPayload) => {
    this.state.showPopUp = true
    this.state.product = payload.product
    this.state.productCard = payload.productCard
    this.state.selectedOptions = payload.selectedOptions
    this.state.trackerKey = payload.trackerKey ? payload.trackerKey : 'quick_shop'
    this.state.searchQuery = payload.searchQuery
    this.state.position = payload.position
    this.state.trackerData = payload.productClickTrackConfig
    this.state.tabData = payload.tabData
    this.state.svdCardToken = payload.svdCardToken
    this.publish()
  }

  hideBuyNowPopUp = () => {
    this.state.showPopUp = false
    this.state.product = null
    this.state.productCard = undefined
    this.state.selectedOptions = []
    this.state.svdCardToken = undefined
    this.publish()
  }

  getProductBuyNowState = () => {
    return this.state
  }
}

const productBuyNowStateManager: ProductBuyNowStateManager =
  ProductBuyNowStateManager.getInstance('productBuyNowStateManager')

export default productBuyNowStateManager
